import { useSyncExternalStore } from 'react';
import type { OnboardingChrome } from './value-first-onboarding';

// The island sits in the app's header, far from the chat that knows the onboarding step. The open value-first chat
// publishes its chrome here, and `AgentsIslandBadge` draws the expanded island while one is published. Each
// publisher clears only its own entry, so a second chat mount (the floating panel and the full chat) closing does
// not take the island from the one still open.

type Entry = { owner: symbol; chrome: OnboardingChrome };

let entry: Entry | null = null;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

export function publishValueFirstIsland(owner: symbol, chrome: OnboardingChrome | null): void {
  if (chrome) {
    if (entry?.owner === owner && entry.chrome === chrome) return;
    entry = { owner, chrome };
    emit();
    return;
  }
  if (entry?.owner !== owner) return;
  entry = null;
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

const read = () => entry?.chrome ?? null;

/** The chrome of the open value-first chat while setup runs, or null — then the island is the regular one. */
export function useValueFirstIsland(): OnboardingChrome | null {
  return useSyncExternalStore(subscribe, read, () => null);
}
